// extracted by mini-css-extract-plugin
module.exports = {"main":"form_main__8p870"};